import { accountApi } from "../account";

const organizationBase = (slug: string) =>
  `/api/account/organizations/${encodeURIComponent(slug)}`;

export function postOrganizationAction<T = unknown>(
  slug: string,
  action: string,
  body: unknown,
) {
  return accountApi<T>(`${organizationBase(slug)}/${action}`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function updateOrganization<T = unknown>(slug: string, body: unknown) {
  return accountApi<T>(organizationBase(slug), {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export function refundOrganizationOrder(
  slug: string,
  orderId: string,
  reason: string,
) {
  return postOrganizationAction(
    slug,
    `orders/${encodeURIComponent(orderId)}/refund`,
    { reason },
  );
}

export function openOrganizationBilling<T extends { url: string }>(
  slug: string,
  destination: "checkout" | "portal",
) {
  return postOrganizationAction<T>(slug, `billing/${destination}`, {});
}
